<div class="wrapper">
    <!-- <app-top-slider [topPromo]="pageService.homePage.top"></app-top-slider> -->
    <app-top-slider [topPromo]="this.pageService.homePage.top"></app-top-slider>

    <div class="searchWrapper">
        <app-search-input (searchEvent)="onSearchSubmit()"></app-search-input>
    </div>

    <!-- <button (click)="throwTestError()">Test Sentry Error</button> -->

    <div class="listWrapper">
        <app-poster-list [title]="'Lionsgate Classics'" [movies]="pageService.homePage.classicsList"></app-poster-list>
    </div>

    <div class="listWrapper">
        <app-poster-list [title]="'New DCP’s'" [movies]="pageService.homePage.newlyCreatedList"></app-poster-list>
    </div>

    <div class="listWrapper">
        <app-poster-list [title]="'Romance'" [movies]="pageService.homePage.romanceList"></app-poster-list>
    </div>

    <!-- <div class="listWrapper">
        <app-poster-list [title]="'Franchise Faves'" [movies]="pageService.homePage.franchiseFavsList"></app-poster-list>
    </div> -->

    <div class="featuredWrapper">
        <app-featured-list [title]="'Featured'" [movies]="pageService.homePage.featuredList"></app-featured-list>
    </div>

    <div class="listWrapper">
        <app-poster-list [title]="'Oscar Winners'"
            [movies]="pageService.homePage.nytTopList"></app-poster-list>
    </div>

    <div class="listWrapper">
        <app-poster-list [title]="'Art House Auteurs'" [movies]="pageService.homePage.spookyList"></app-poster-list>
    </div>

    <app-top-slider [topPromo]="this.pageService.homePage.bottom"></app-top-slider>

    <div class="listWrapper">
        <app-poster-list [title]="'American Indie Classics'" [movies]="pageService.homePage.horrorList"></app-poster-list>
    </div>

    <!-- <div class="listWrapper">
        <app-poster-list [title]="'Filmmaker Spotlight: Tarantino'"
            [movies]="pageService.homePage.tarantinoList"></app-poster-list>
    </div> -->

    <!-- <div class="listWrapper padd1">
        <app-square-list [title]="'Franchises'" [SquarePromo]="pageService.homePage.franciseList"></app-square-list>
    </div> -->


    <div class="listWrapper">
        <app-square-list [title]="'Franchises'" [SquarePromo]="pageService.homePage.franciseList"
            [numberOnScreen]="5"></app-square-list>
    </div>


    <!-- <div class="listWrapper">
        <app-poster-list [title]="'Action Asskickers'"
            [movies]="pageService.homePage.actionList"></app-poster-list>
    </div> -->


</div>